import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import { GrLocation } from "react-icons/gr";
import config from "../../../../config/config";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE
} from "../../../../common/Constant";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import Loader from "../../../../components/Loader/Loader";

const Locations = (props) => {
  let navigate = useNavigate();
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");

  const [loading, setLoading] = useState(false);

  const [locationData, setLocationData] = useState([]);
  const [taxGroup, setTaxGroup] = useState([]);
  const [locationItem, setLocationItem] = useState([]);
  const [totalLocation, setTotalLocation] = useState([]);
  const [hideGridValues, setHideGridValues] = useState({});
  const [doNotSellValues, setDoNotSellValues] = useState({});
  const [overRidePricesValues, setOverRidePricesValues] = useState([]);
  const [overDefaultTaxValues, setOverDefaultTaxValues] = useState([]);

  // Dropdown Styles
  // const selectStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //   }), // dropdown input css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     position: "absolute",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }), // dropdown menu css
  // };

  // Tax Group DropDown
  let taxGroupOptions = [];
  const TaxGroupDropDown = taxGroup.map((u, i) => {
    taxGroupOptions[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const handleCheckBoxChange = (index, value, fieldName) => {
    // For DoNotSell
    if (fieldName === "DoNotSell") {
      const updatedData = [...locationData];
      updatedData[index] = {
        ...updatedData[index],
        DoNotSell: value === true ? 1 : 0,
      };

      setLocationItem(updatedData);
    }
    // For HideGrid
    else if (fieldName === "HideGrid") {
      const updatedData = [...locationData];
      updatedData[index] = {
        ...updatedData[index],
        HideGrid: value === true ? 1 : 0,
      };
      setLocationItem(updatedData);
    }
  };

  // Handle function for Location values
  const handleChangeForValues = (index, event, fieldName) => {
    let name, values;

    if (fieldName === "TaxGroup") {
      name = fieldName;
      values = event.value;
    } else if (event.target.type === "checkbox") {
      name = event.target.name;
      values = event.target.checked === true ? 1 : 0;
    } else {
      name = event.target.name;
      values = event.target.value;
    }

    let cardInput = [...locationItem];
    if (cardInput[index]) {
      cardInput[index][name] = values;
      setLocationItem(cardInput);
    }
  };

  // Handle Change for OverridePrices CheckBox
  const handleOverridePricesChange = (index, event) => {
    const newCheckboxes = [...overRidePricesValues];
    newCheckboxes[index] = !newCheckboxes[index];
    setOverRidePricesValues(newCheckboxes);
  };

  // Handle Change for OverrideDefaultTax CheckBox
  const handleOverrideDefaultTaxChange = (index, event) => {
    const newCheckboxes = [...overDefaultTaxValues];
    newCheckboxes[index] = !newCheckboxes[index];
    setOverDefaultTaxValues(newCheckboxes);
  };

  // Action Button Function
  const ActionButtons = (props) => {
    const handleBack = () => {
      props.previousStep();
      window.scrollTo(0, 0);
    };

    return (
      <div className="text-center">
        {props.currentStep > 1 && (
          <button onClick={handleBack} className="btn btn-primary me-3">
            Back
          </button>
        )}

        <button onClick={handleSubmit} className="btn btn-primary me-3">
          Submit
        </button>
      </div>
    );
  };

  useEffect(() => {
    //  Binding TaxGroup DropDown
    axios
      .get(`${config.generalBaseUrl}/generals/taxesdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setTaxGroup(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("error: " + err);
      });

    // Binding Location Fields
    axios
      .get(`${config.priceRulesBaseUrl}/pricerules/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLoading(false);
        setTotalLocation(res.data.ResponseData);
        if (paramObject.id > 0) {
          // For Binding the data for Updated time
          axios
            .get(
              `${config.itemKitsBaseUrl}/itemkits/locationfindbyid?id=${paramObject.id}`,
              {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                  Authorization: token,
                },
              }
            )
            .then((res) => {
              console.log(res.data.ResponseData);
              if (res.data.ResponseData.ItemKits.length > 0) {
                let overridedefault = [];
                let overtaxdefault = [];

                // For setting the state of the overrideDefaults and overTaxDefault
                for (
                  let i = 0;
                  i < res.data.ResponseData.ItemKits.length;
                  i++
                ) {
                  overridedefault.push(
                    res.data.ResponseData.ItemKits[i].OverridePrices === 1
                      ? true
                      : false
                  );
                  overtaxdefault.push(
                    res.data.ResponseData.ItemKits[i].OverrideTax === 1
                      ? true
                      : false
                  );
                }

                setOverRidePricesValues(overridedefault);
                setOverDefaultTaxValues(overtaxdefault);

                // Location Data handling
                let itemkits = [];
                for (
                  let i = 0;
                  i < res.data.ResponseData.ItemKits.length;
                  i++
                ) {
                  let taxItemKitsData =
                    res.data.ResponseData.Itemkitslocationtaxes.filter(
                      function (locationItem) {
                        return (
                          locationItem.LocationId ===
                          res.data.ResponseData.ItemKits[i].LocationId
                        );
                      }
                    );

                  itemkits.push({
                    LocationItemId: res.data.ResponseData.ItemKits[i].Id,
                    LocationId: res.data.ResponseData.ItemKits[i].LocationId,
                    DoNotSell: res.data.ResponseData?.ItemKits[i].DoNotSell,
                    HideGrid: res.data.ResponseData.ItemKits[i].HideGrid,
                    OverridePrices:
                      res.data.ResponseData.ItemKits[i].OverridePrices,
                    CostPrice: parseFloat(
                      res.data.ResponseData.ItemKits[i].CostPrice
                    ),
                    UnitPrice: parseFloat(
                      res.data.ResponseData.ItemKits[i].UnitPrice
                    ),
                    OverrideTax: res.data.ResponseData.ItemKits[i].OverrideTax,
                    TaxCumulative:
                      res.data.ResponseData.Itemkitslocationtaxes[i].Cumulative,
                    TaxGroup: res.data.ResponseData.ItemKits[i].TaxGroup,
                    Tax1: taxItemKitsData[0].Name,
                    Tax2: taxItemKitsData[1].Name,
                    Tax3: taxItemKitsData[2].Name,
                    Tax4: taxItemKitsData[3].Name,
                    Tax5: taxItemKitsData[4].Name,
                    TaxPercentage1: parseFloat(taxItemKitsData[0].Percent),
                    TaxPercentage2: parseFloat(taxItemKitsData[1].Percent),
                    TaxPercentage3: parseFloat(taxItemKitsData[2].Percent),
                    TaxPercentage4: parseFloat(taxItemKitsData[3].Percent),
                    TaxPercentage5: parseFloat(taxItemKitsData[4].Percent),
                    Tax1Id: taxItemKitsData[0].Id,
                    Tax2Id: taxItemKitsData[1].Id,
                    Tax3Id: taxItemKitsData[2].Id,
                    Tax4Id: taxItemKitsData[3].Id,
                    Tax5Id: taxItemKitsData[4].Id,
                  });
                }
                setLocationItem(itemkits);

                // Location Tax Handling
                let taxitemkits = [];
                for (
                  let i = 0;
                  i < res.data.ResponseData.Itemkitslocationtaxes.length;
                  i++
                ) {
                  taxitemkits.push({
                    LocationId:
                      res.data.ResponseData.Itemkitslocationtaxes[i].LocationId,
                    TaxId: res.data.ResponseData.Itemkitslocationtaxes[i].Id,
                    TaxName:
                      res.data.ResponseData.Itemkitslocationtaxes[i].Name,
                    TaxPercent:
                      res.data.ResponseData.Itemkitslocationtaxes[i].Percent,
                    TaxCumulative:
                      res.data.ResponseData.Itemkitslocationtaxes[i].Cumulative,
                  });
                }

                setLoading(false);
              } else {
                axios
                  .get(
                    `${config.priceRulesBaseUrl}/pricerules/locationdropdown`,
                    {
                      headers: {
                        "Content-Type": "application/json;charset=UTF-8",
                        Authorization: token,
                      },
                    }
                  )
                  .then((res) => {
                    let locationlength = res.data.ResponseData.length;

                    let itemkits = [];
                    for (let i = 0; i < locationlength; i++) {
                      itemkits.push({
                        LocationItemId: 0,
                        LocationId: res.data.ResponseData[i].Id,
                        DoNotSell: 0,
                        HideGrid: 0,
                        OverridePrices: 0,
                        CostPrice: 0,
                        UnitPrice: 0,
                        OverrideTax: 0,
                        TaxCumulative: 0,
                        Tax1: "",
                        Tax2: "",
                        Tax3: "",
                        Tax4: "",
                        Tax5: "",
                        TaxPercentage1: 0,
                        TaxPercentage2: 0,
                        TaxPercentage3: 0,
                        TaxPercentage4: 0,
                        TaxPercentage5: 0,
                      });
                    }
                    setLocationItem(itemkits);
                  })
                  .catch((err) => {
                    console.log("err: ", err);
                  });
              }
            })
            .catch((err) => {
              console.log("err: ", err);
            });
        }
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  }, []);

  // Handle all the UPSERT events
  const handleSubmit = () => {
    // For Location Taxes
    // To change all the taxes format
    const numLocations = locationItem.length;
    const numTaxesPerLocation = Math.ceil(locationItem.length / numLocations);
    const taxArray = [];

    for (let locationIndex = 0; locationIndex < numLocations; locationIndex++) {
      const startTaxIndex = locationIndex * numTaxesPerLocation;
      const endTaxIndex = startTaxIndex + numTaxesPerLocation;
      const taxes = [];

      for (let i = startTaxIndex; i < endTaxIndex; i++) {
        const itemkits = locationItem[i];
        for (let j = 1; j <= 5; j++) {
          if (itemkits[`Tax${j}`]) {
            taxes.push({
              LocationId: locationIndex + 1,
              TaxId:
                itemkits[`Tax${j}Id`] == undefined ? 0 : itemkits[`Tax${j}Id`],
              TaxName: itemkits[`Tax${j}`],
              TaxPercent: itemkits[`TaxPercentage${j}`],
              TaxCumulative: itemkits[`TaxCumulative`],
            });
          }
        }
      }

      taxArray.push(taxes);
    }

    const mergedTaxArr = [].concat(...taxArray);

    // To filter all null values of Location data
    let LocationItemData = locationItem.filter(function (locationItem) {
      return locationItem.LocationId !== "";
    });

    // To filter all null values of Taxes  data
    let TaxItemData = mergedTaxArr.filter(function (taxItem) {
      return taxItem.TaxName !== "";
    });

    // XML object declare
    const locationItemobj = {};
    const taxItemobj = {};

    // After filtering the array to set to particular object
    locationItemobj.LocationItemKitsDataXML = LocationItemData;
    taxItemobj.LocationItemKitsTaxDataXML = TaxItemData;

    // Object are converted to JSON string
    let locationitemjsonstring = JSON.stringify(locationItemobj);
    let taxitemjsonstring = JSON.stringify(taxItemobj);
    console.log("locationitemjsonstring ===>", locationitemjsonstring);
    console.log("taxitemjsonstring ==>", taxitemjsonstring);
    setLoading(true);

    // Location Upsert API Call
    axios
      .post(
        `${config.itemKitsBaseUrl}/itemkits/locationupsert`,
        {
          locationitemkitsxml: locationitemjsonstring,
          taxxml: taxitemjsonstring,
          itemkitid: paramObject.id || 0,
          loginuserid: Id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          navigate("/item-Kits");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error: ", error);
      });
  };

  const handleBack = () => {
    props.previousStep();
    window.scrollTo(0, 0);
  };

  return (
    <>
      <Loader loading={loading} />
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title">
            <GrLocation className="me-1" />
            Locations
          </h5>
          <div>
            {props.currentStep > 1 && (
              <button
                onClick={handleBack}
                className="btn btn-primary btn-md me-1"
              >
                Back
              </button>
            )}
          </div>
        </div>
      </div>
      {totalLocation?.map((data, locationIndex) => {
        return (
          <>
            <div className="for-box mb-5">
              <div className="card">
                <div className="card-header">
                  <div className="mt-1 fw-bolder fs-6 ">
                    <GrLocation className="me-1" />
                    {data.Name} (Fields in red are required)
                  </div>
                </div>

                <div className="card-body">
                  <Formik
                    {...props}
                    initialValues={locationItem}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    <Form>
                      <div className="row">
                        <div className="col-md-3 mb-3">
                          <input
                            type="hidden"
                            name="LocationId"
                            value={data.Id}
                          />
                          <Field
                            type="checkbox"
                            style={{ width: "1.25em", height: "1.25em" }}
                            className="checkbox form-check-input me-3 mx-4"
                            id={`DoNotSell`}
                            name={`DoNotSell`}
                            checked={
                              paramObject.id > 0
                                ? locationItem[locationIndex]?.DoNotSell === 1
                                : doNotSellValues[
                                    `checkbox${locationIndex + 1}`
                                  ]
                            }
                            onChange={(event) =>
                              handleChangeForValues(locationIndex, event)
                            }
                          />

                          <label className="form-check-label me-3">
                            Do Not Sell At This Location
                          </label>
                        </div>
                        <div className="col-md-2 ms-3">
                          <Field
                            type="checkbox"
                            style={{ width: "1.25em", height: "1.25em" }}
                            className="checkbox form-check-input me-3"
                            id={`HideGrid`}
                            name={`HideGrid`}
                            checked={
                              paramObject.id > 0
                                ? locationItem[locationIndex]?.HideGrid === 1
                                : hideGridValues[`checkbox${locationIndex + 1}`]
                            }
                            onChange={(event) =>
                              handleChangeForValues(locationIndex, event)
                            }
                          />
                          <label className="form-check-label me-3">
                            Hide From Grid
                          </label>
                        </div>
                      </div>

                      <div className="col-md-12 mb-3">
                        <Field
                          type="checkbox"
                          style={{ width: "1.25em", height: "1.25em" }}
                          className="checkbox form-check-input me-3 mx-4"
                          id={`OverridePrices`}
                          name={`OverridePrices`}
                          checked={
                            locationItem[locationIndex]?.OverridePrices === 1
                          }
                          onChange={(event) => {
                            handleOverridePricesChange(locationIndex, event);
                            handleChangeForValues(locationIndex, event);
                          }}
                        />
                        <label className="form-check-label me-3">
                          Override Prices
                        </label>
                      </div>
                      {overRidePricesValues[locationIndex] && (
                        <>
                          <div>
                            <div className="row">
                              <div className="col-md-2 mb-3 align-center">
                                <label className="form-label">
                                  Cost Price (Without Tax):
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <Field
                                  type="text"
                                  className="form-control"
                                  id={`CostPrice`}
                                  name={`CostPrice`}
                                  value={locationItem[locationIndex]?.CostPrice}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3 align-center">
                                <label className="form-label">
                                  Selling Price:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <Field
                                  type="text"
                                  className="form-control"
                                  id={`UnitPrice`}
                                  name={`UnitPrice`}
                                  value={locationItem[locationIndex]?.UnitPrice}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="col-md-12 mb-3">
                        <Field
                          type="checkbox"
                          style={{ width: "1.25em", height: "1.25em" }}
                          className="checkbox form-check-input me-3 mx-4"
                          id={`OverrideTax`}
                          name={`OverrideTax`}
                          checked={
                            locationItem[locationIndex]?.OverrideTax === 1
                          }
                          onChange={(event) => {
                            handleOverrideDefaultTaxChange(
                              locationIndex,
                              event
                            );
                            handleChangeForValues(locationIndex, event);
                          }}
                        />
                        <label className="form-check-label me-3">
                          Override Default Tax
                        </label>
                      </div>
                      {overDefaultTaxValues[locationIndex] && (
                        <>
                          <div className="row">
                            <div className="col-md-2">
                              <label className="align-center">Tax Group:</label>
                            </div>
                            <div className="col-md-10 mb-3">
                              <Select
                                onChange={(event) =>
                                  handleChangeForValues(
                                    locationIndex,
                                    event,
                                    "TaxGroup"
                                  )
                                }
                                value={taxGroupOptions.find(
                                  (obj) =>
                                    obj.value ==
                                    locationItem[locationIndex]?.TaxGroup
                                )}
                                options={taxGroupOptions}
                                backspaceRemovesValue={false}
                                controlShouldRenderValue={true}
                                isClearable={true}
                                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                id="TaxGroup"
                                name="TaxGroup"
                              />
                            </div>
                            <h4 className="col-md-12 align-center">OR</h4>
                            <div className="row mt-2">
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 1:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax1`}
                                  name={`Tax1`}
                                  value={locationItem[locationIndex]?.Tax1}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage1`}
                                    name={`TaxPercentage1`}
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage1
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 2:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax2`}
                                  name={`Tax2`}
                                  value={locationItem[locationIndex]?.Tax2}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage2`}
                                    name={`TaxPercentage2`}
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage2
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 3:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax3`}
                                  name={`Tax3`}
                                  value={locationItem[locationIndex]?.Tax3}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage3`}
                                    name={`TaxPercentage3`}
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage3
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 4:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax4`}
                                  name={`Tax4`}
                                  value={locationItem[locationIndex]?.Tax4}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage4`}
                                    name={`TaxPercentage4`}
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage4
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                            </div>

                            <div className="row mt-2">
                              <div className="col-md-2">
                                <label className="align-center mt-2">
                                  Tax 5:
                                </label>
                              </div>
                              <div className="col-md-2 mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  id={`Tax5`}
                                  name={`Tax5`}
                                  value={locationItem[locationIndex]?.Tax5}
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />
                              </div>
                              <div className="col-md-2 mb-3">
                                <div className="input-group mb-3">
                                  <input
                                    type="number"
                                    className="form-control"
                                    id={`TaxPercentage5`}
                                    name={`TaxPercentage5`}
                                    defaultValue={
                                      locationItem[locationIndex]
                                        ?.TaxPercentage5
                                    }
                                    onChange={(event) =>
                                      handleChangeForValues(
                                        locationIndex,
                                        event
                                      )
                                    }
                                  />
                                  <span className="input-group-text">%</span>
                                </div>
                              </div>
                              <div className="col-md-4 ms-4 mb-3">
                                <Field
                                  type="checkbox"
                                  style={{ width: "1.25em", height: "1.25em" }}
                                  className="checkbox form-check-input ms-5 me-4"
                                  id={`TaxCumulative`}
                                  name={`TaxCumulative`}
                                  checked={
                                    locationItem[locationIndex]
                                      ?.TaxCumulative === 1
                                  }
                                  onChange={(event) =>
                                    handleChangeForValues(locationIndex, event)
                                  }
                                />

                                <label className="form-check-label">
                                  Tax Cumulative
                                </label>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </Form>
                  </Formik>
                </div>
              </div>
            </div>
          </>
        );
      })}

      {totalLocation?.length > 0 && <ActionButtons {...props} />}
    </>
  );
};

export default Locations;
